/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BarWave } from 'react-cssfx-loading';
// Brand icons (e.g. Facebook, Twitter)
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';

// Solid icons (e.g. Users, Lightbulb)
import {
  faUsers,
  faLightbulb,
  faHandshake,
  faChartLine,
  faShieldAlt,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';

// import { useAddNewsletterSubscriberMutation } from '../../redux/public/publicSlice';
import { useAddNewsletterSubscriberMutation } from '../../redux/apiSlice';

function Footer() {
  const [addemail] = useAddNewsletterSubscriberMutation();
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setEmail(e.target.value);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await addemail({ email });
      if (result.data) {
        setSuccessMessage('Congratulations 🎉 You have subscribed to our Newsletter.');
        setErrorMessage('');
        setEmail('');
      } else if (result.error) {
        setErrorMessage('Sorry, you are already subscribed.');
        setSuccessMessage('');
      }
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-darkblue text-white pt-10">
      {/* Core Values */}
      <div className="max-w-6xl mx-auto px-4 py-8">
        <h2 className="text-lg font-bold text-center mb-6 text-gray-200 tracking-wide">Our Core Values</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: faUsers, title: 'Customer Focus', desc: 'We value and recognize the contribution of our customers towards development of the aviation industry.' },
            { icon: faCheckCircle, title: 'Accountability', desc: 'We take responsibility for our actions and account for them at all levels.' },
            { icon: faHandshake, title: 'Team Work', desc: 'Ours is a team of purpose, working together towards a common goal.' },
            { icon: faChartLine, title: 'Efficiency', desc: 'We avoid wasteful expenditure and ensure optimal utilization of resources.' },
            { icon: faLightbulb, title: 'Innovation', desc: 'We continuously devise ways to improve service delivery and embrace new ideas.' },
            { icon: faShieldAlt, title: 'Integrity', desc: 'We conduct our business in accordance with the highest standards of professional behavior and ethics.' },
          ].map((v) => (
            <div key={v.title} className="bg-gray-800 bg-opacity-60 rounded-lg p-4 flex flex-col items-center shadow hover:shadow-lg transition">
              <FontAwesomeIcon icon={v.icon} className="text-yellow-400 text-3xl mb-2" />
              <h3 className="font-semibold text-md mb-1 text-gray-100">{v.title}</h3>
              <p className="text-xs text-gray-400 text-center">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Newsletter */}
      <div className="bg-gray-900 bg-opacity-80 py-8">
        <div className="max-w-2xl mx-auto rounded-xl shadow-lg p-6 flex flex-col items-center">
          <h2 className="text-xl font-bold mb-2 text-white">Subscribe to our Newsletter</h2>
          <p className="text-gray-400 mb-4 text-center">Get the latest updates and news directly to your inbox.</p>
          <form onSubmit={handleSubscribe} className="flex w-full max-w-md">
            <input
              className="flex-1 p-3 rounded-l-lg border-0 focus:ring-2 focus:ring-blue-400 text-gray-800"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={handleChange}
              required
            />
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-semibold px-6 rounded-r-lg transition"
              type="submit"
              disabled={loading}
            >
              {loading ? <BarWave color="#fff" width="30px" height="30px" /> : 'Subscribe'}
            </button>
          </form>
          {errorMessage && <p className="text-red-400 mt-2">{errorMessage}</p>}
          {successMessage && <p className="text-green-400 mt-2">{successMessage}</p>}
        </div>
      </div>

      {/* Copyright & Social */}
      <div className="border-t border-gray-700 mt-8 pt-6 pb-2 flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto px-4">
        <div className="text-gray-400 text-sm mb-2 md:mb-0">
          <span className="font-bold text-white">DANS ANS SMS</span>
          <br />
          &copy;
          <br />
          {currentYear}
          <br />
          SMS Portal. All rights reserved.
        </div>
        <div className="flex gap-6">
          <a href="https://twitter.com/UgandaCAA" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faTwitter} className="text-blue-400 text-xl hover:text-blue-600 transition" />
          </a>
          <a href="https://www.facebook.com/Ugandacaa/" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebook} className="text-blue-600 text-xl hover:text-blue-800 transition" />
          </a>
          <a href="https://www.instagram.com/ugandacaa/?hl=en" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} className="text-pink-400 text-xl hover:text-pink-600 transition" />
          </a>
          <a href="https://ug.linkedin.com/company/uganda-civil-aviation-authority" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faLinkedin} className="text-blue-500 text-xl hover:text-blue-700 transition" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
